CustomerAccountManageInvoicesController.$inject = ["API_URL", "$http", "$q", "$timeout", "$rootScope", "$filter"];
angular.module('calendarApp').controller('CustomerAccountManageInvoicesController', CustomerAccountManageInvoicesController);

function CustomerAccountManageInvoicesController(API_URL, $http, $q, $timeout, $rootScope, $filter) {
  var update = this,
      throbber = $rootScope.throbber;
  update.updatePaymentMethod = true;
  update.invoiceToPay = null;
  if (!window.Stripe) return $rootScope.throbber.showError("Sorry but an error occurred: could not connect to Stripe. Please try re-loading the page. ");

  update.chooseInvoice = function (index) {
    update.invoiceToPay = update.outstandingInvoices[index];
  };

  update.cancelInvoice = function (index) {
    if (!confirm('Please confirm you would like to cancel this invoice.')) return;
    var invoice = update.outstandingInvoices[index];
    $http.put("".concat(API_URL, "/api/v1/calendar/membership/payments/cancel-subscription/").concat(invoice.stripesubscriptionid)).then(function (_ref) {
      var response = _ref.data;
      update.loading = false;
      throbber.hide('Invoice cancelled successfully');

      if (!response.success) {
        return throbber.showError("Sorry but an error occurred with this request: ".concat(response.msg));
      }

      init();
    }).catch(function (err) {
      update.loading = false;
      throbber.showError("Sorry but an error occurred with this request: ".concat(err.message));
    });
  };

  var init = function init() {
    throbber.show();
    update.loading = true;
    $http.get("".concat(API_URL, "/api/v1/calendar/membership/payments/unpaid-invoices")).then(function (_ref2) {
      var response = _ref2.data;
      update.loading = false;
      throbber.hide();

      if (!response.success) {
        return throbber.showError("Sorry but an error occurred with this request: ".concat(response.msg));
      }

      update.outstandingInvoices = response.outstandingInvoices;
    }).catch(function (err) {
      update.loading = false;
      throbber.showError("Sorry but an error occurred with this request: ".concat(err.message));
    });
  };

  init();
}